<div [class]="containerClasses()">
  <div>
    <img [src]="logo()" [alt]="altText()" />
  </div>
</div>
